import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import LuxuryEscapesSmallLogo from '../Header/Logo/logos/LuxuryEscapesSmallLogo'
import { DevPanelData } from './types'
import Pane from 'components/Common/Pane'
import ContextsTab from './tabs/ContextsTab'
import ReduxTab from './tabs/ReduxTab'
import { HorizontalLayout, Content, Sidebar, VerticalLayout, MenuItem } from './common'
import { useSessionPersistedTabs } from './hooks'

const RootLayout = styled.div`
  height: 100vh;
`

const Logo = styled(LuxuryEscapesSmallLogo)`
  height: ${rem(28)};
  width: ${rem(28)};
`

const tabs = [
  { id: 'contexts', label: 'Contexts', component: ContextsTab },
  { id: 'redux', label: 'Redux state', component: ReduxTab },
] as const

const tabIds = tabs.map(tab => tab.id)

const TAB_STORAGE_KEY = 'DevPanel:selectedTab'

interface Props {
  state: DevPanelData
}

function DevPanelRoot({ state }: Props) {
  const [currentTabId, setTab] = useSessionPersistedTabs(tabIds, TAB_STORAGE_KEY)

  const currentTab = tabs.find(tab => tab.id === currentTabId)!
  const TabContent = currentTab.component

  return <RootLayout>
    <VerticalLayout>
      <Pane padding={20}>
        <HeadingTextBlock variant="heading3" startIcon={<Logo />}>Customer portal dev panel</HeadingTextBlock>
      </Pane>

      <Content>
        <HorizontalLayout>
          <Sidebar>
            {tabs.map(tab => (
              <MenuItem key={tab.id} onClick={setTab[tab.id]} title={tab.label} selected={tab.id === currentTabId} />
            ))}
          </Sidebar>

          <Content>
            <TabContent state={state} />
          </Content>
        </HorizontalLayout>
      </Content>
    </VerticalLayout>
  </RootLayout>
}

export default DevPanelRoot
